import type { BatchCosignBody, BatchCosignResponse } from "@/core/types";
import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";

export async function batchCosignAction(body: BatchCosignBody): Promise<BatchCosignResponse> {
  return cosignatureRequestsTyped.batch_cosign({ body });
}
